module.exports = __webpack_public_path__ + "images/login_icon_code_yellow.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/login_icon_code_yellow.png
// module id = 872
// module chunks = 121